import publicContractList from "./publicContractList";
export default [publicContractList];
